<template>
  <!-- <v-container fluid> -->
  <v-layout column class="info-width">
    <!-- MESSAGES -->
    <v-dialog
      v-model="showMessage"
      max-width="390"
      persistent
    >
      <v-card width="390">
        <v-card-title primary-title>
          <div>
            <div class="headline">{{ messageToShow }}</div>
            <span>
              Recuerde que la información de Alarmas ha cambiado, por eso se recomienda hacer click en el botón <v-icon small>replay</v-icon> recargar.
            </span>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="fetchMissionAlarmsIn"
          >
            <v-icon left>replay</v-icon>
            Recargar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- JUSTIFICATION COMPONENT -->
    <v-dialog
      v-model="showJustification"
      max-width="390"
      persistent
    >
      <justification-alert
        :alarm='alarmSelected'
        :alarmsPendingToManualReload='alarmsPendingToManualReload'
        @showDialog='showJustification = false'
        @showMessage='showMessageIn'
        @fetchMissionAlarmsIn='fetchMissionAlarmsIn'
      />
    </v-dialog>
    <!-- MESSAGE RELOAD ALARMS REQUEST -->
    <v-snackbar
      v-model="showReloadAlarmsMessage"
      :timeout="0"
      :top="true"
      color="grey darken-3"
      auto-height
    >
      <v-layout column>
        <v-flex>
          <v-icon left large>warning</v-icon>
          <p>
            La información de las Alarmas ha cambiado, por eso se recomienda hacer click en el botón <v-icon small>replay</v-icon> recargar.
          </p>
        </v-flex>
        <v-flex d-flex>
          <v-btn
            color="primary"
            @click="fetchMissionAlarmsIn"
          >
            <v-icon left>replay</v-icon>
            Recargar
          </v-btn>
          <v-btn
            color="error"
            @click="cancelMessage"
          >
            <v-icon left>clear</v-icon>
            Cerrar
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <!-- INFO ALERTS -->
    <v-flex d-inline-flex align-center class="general-info-container" pa-3 mb-1>
      <v-flex style="max-width: 250px; min-width: 250px;">
        <h2>Salidas de Geocerca</h2>
      </v-flex>
      <v-flex
        v-if="!loadingMissionAlarms"
        style="max-width: 190px; min-width: 190px;"
      >
        <h3 class="pl-2"><span class="body-2">Total Alarmas:</span> {{ missionAlarms.length }}</h3>
      </v-flex>
    </v-flex>
    <!-- MANUAL RELOAD REMEMBER MESSAGE -->
    <v-flex
      v-if="alarmsPendingToManualReload"
      class="message-reload-pending"
      pl-3
      my-1
    >
      <v-flex d-inline-flex align-center>
        <v-flex>
          <v-icon left color="grey darken-3">warning</v-icon>
        </v-flex>
        <v-flex class="caption font-weight-medium">
          Recuerde que la información de Alarmas ha cambiado, por eso se recomienda hacer click en el botón recargar:
        </v-flex>
        <v-flex>
          <v-btn
            flat
            icon
            color="grey darken-3"
            @click="fetchMissionAlarmsIn"
          >
            <v-icon>replay</v-icon>
          </v-btn>
        </v-flex>
      </v-flex>
    </v-flex>
    <!-- HEADER -->
    <v-flex d-flex py-1 mb-1 class="text-xs-left header-container">
      <v-flex class="text-xs-left info-mission" pl-4>Nombre</v-flex>
      <v-flex ml-5 class="description-style">Descripción</v-flex>
      <!-- <v-flex ml-5 pl-1>Donde</v-flex> -->
      <v-flex >Vehículos</v-flex>
    </v-flex>
    <!-- LOADING -->
    <v-flex v-if="loadingMissionAlarms" pa-5>
      <v-progress-circular indeterminate color="white"></v-progress-circular>
      Cargando datos...
    </v-flex>
    <!-- CONTENT -->
    <v-flex v-else>
      <!-- ALARM DATA -->
      <v-flex v-if="missionAlarms.length > 0">
        <v-expansion-panel focusable>
          <v-expansion-panel-content
            v-for="(alarm, index) in missionAlarms"
            :key="index">
            <!-- HEADER -->
            <template v-slot:header>
              <v-flex d-flex class="text-xs-left" align-center>
                <v-flex class="info-mission">
                  {{ alarm.name }}
                </v-flex>
                <v-flex pl-2 class="description-style">{{ alarm.description }}</v-flex>
                <!-- <v-flex offset-xs1>{{ alarm.where }}</v-flex> -->
                <v-flex ml-5 offset-xs0>{{ alarm.vehicles.length }}</v-flex>
              </v-flex>
            </template>
            <!-- CONTENT -->
            <v-card class="pt-3" color="grey darken-4">
              <v-card-text>
                <h3 class="ml-5">Vehículos</h3>
                <v-flex ml-5 mb-1 px-2>
                  <v-flex d-inline-flex class="body-2 grey--text">
                    <v-flex class="plate-style caption font-weight-bold">
                      Placa
                    </v-flex>
                    <v-flex class="code-style caption font-weight-bold">
                      Código/Sigla
                    </v-flex>
                    <v-flex class="agency-style caption font-weight-bold" pl-5>
                      Agencia
                    </v-flex>
                    <v-flex class="date-style caption font-weight-bold" pl-5>
                      Desde
                    </v-flex>
                    <v-flex class="date-style caption font-weight-bold" pl-5>
                      Hasta
                    </v-flex>
                    <v-flex class="justification-style caption font-weight-bold">
                      Justificación
                    </v-flex>
                  </v-flex>
                </v-flex>
                <v-flex
                  v-for="(vehicle, index) in alarm.vehicles"
                  :key="index"
                  pl-5>
                  <v-flex 
                    d-inline-flex
                    align-center
                    :class="[index % 2 ? '' : rowbg]"
                    class="info-vehicle-in caption"
                    px-2
                    py-1
                  >
                    <v-flex class="plate-style">
                      <router-link class="caption" :to="`/vehicles/${vehicle.id}`">
                        {{ vehicle.licensePlate === null ? '' : vehicle.licensePlate }}
                      </router-link>
                    </v-flex>
                    <v-flex class="plate-style">
                      <router-link class="caption" :to="`/vehicles/${vehicle.id}`">
                        {{ vehicle.code === null ? '' : vehicle.code }}
                      </router-link>
                    </v-flex>
                    <v-flex class="agency-style" pl-5>
                      {{ vehicle.agencyId | agencyName }}
                    </v-flex>
                    <v-flex class="date-style" pl-1>
                      {{ vehicle.startTime | filterFullDate }}
                    </v-flex>
                    <v-flex class="date-style" pl-1>
                      {{ vehicle.endTime | filterFullDate }}
                    </v-flex>
                    <v-flex class="justification-style">
                      <v-flex
                        v-if="vehicle.isJustified === null"
                        :class="vehicle.userInProgressRemote ? 'in-progress-state' : ''"
                        d-inline-flex
                        align-center
                      >
                        <!-- NULL -->
                        <v-btn
                          fab
                          small
                          flat
                          :disabled="vehicle.justificationInProgress"
                          @click="justifyAlert(vehicle, alarm.name, alarm.description)"
                        >
                          <v-icon
                            v-if="vehicle.userInProgressRemote"
                            color="grey lighten-1"
                          >
                            textsms
                          </v-icon>
                          <v-icon
                            v-else
                            color="grey lighten-1"
                          >
                            chat_bubble
                          </v-icon>
                        </v-btn>
                        <!-- USER IN PROGRESS -->
                        <v-tooltip
                          left
                          color="amber lighten-2 grey--text text--darken-3"
                        >
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-if="vehicle.userInProgressRemote"
                              class="hover-icon"
                              style="margin-left:-15px"
                              color="amber"
                              v-on="on"
                            >
                              record_voice_over
                            </v-icon>
                          </template>
                          <span>
                            ...justificando
                            <br />
                             <b>{{ vehicle.userInProgressRemote }}</b>
                          </span>
                        </v-tooltip>
                      </v-flex>
                      <!-- FALSE -->
                      <v-btn
                        v-else-if="vehicle.isJustified === false"
                        fab
                        small
                        flat
                        @click="justifyAlert(vehicle, alarm.name, alarm.description)"
                      >
                        <v-icon color="error">report_off</v-icon>
                      </v-btn>
                      <!-- TRUE -->
                      <v-btn
                        v-else-if="vehicle.isJustified === true"
                        fab
                        small
                        flat
                        @click="justifyAlert(vehicle, alarm.name, alarm.description)"
                      >
                        <v-icon color="success">message</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-flex>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      <!-- MESSAGE -->
      <v-flex v-else px-3 py-3>
        <h2>En éste momento no hay alarmas por salida de geocerca.</h2>
        <p>A medida que se generen nuevas alarmas, éstas se cargaran automáticamente.</p>
      </v-flex>
    </v-flex>
  </v-layout>
  <!-- </v-container> -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import JustificationAlert from './JustificationAlert'

export default {
  name: 'missions-alerts',
  components: {
    JustificationAlert
  },
  data() {
    return {
      alarmSelected: {},
      showJustification: false,
      rowbg: 'bg-row',
      intervalInstance1: null,
      alarmsPendingToManualReload: false,
      showMessage: false,
      messageToShow: ''
    }
  },
  watch: {
    role(newValue, oldValue) {
      // console.log('WATCH ROLE: ', newValue, oldValue)
      if (newValue === oldValue || newValue[0] !== 23) return
      if (this.role !== null && this.role.length === 1 && this.role[0] === 23) {
        this.fetchMissionAlarms()
        this.intervalInstance1 = setInterval(() => {
          // console.log('fetchMissionAlarms WATCH ROLE TIME OUT')
          this.fetchMissionAlarms()
        }, this.intervalValueMissioAlarms)
        this.setMissionAlertsIntervalInstance(this.intervalInstance1)
      }
    },
    adminRole(newValue, oldValue) {
      // console.log('WATCH ADMIN ROLE: ', newValue, oldValue)
      if (this.adminRole !== null) {
        this.fetchMissionAlarms()
        this.intervalInstance1 = setInterval(() => {
          // console.log('fetchMissionAlarms WATCH ADMIN ROLE TIME OUT')
          this.fetchMissionAlarms()
        }, this.intervalValueMissioAlarms)
      }
      this.setMissionAlertsIntervalInstance(this.intervalInstance1)
    }
    // missionAlarms(newValue, oldValue) {
    //   console.log('WATCH MISSION ALARMS:', newValue, oldValue)
    // }
  },
  computed: {
    ...mapGetters([
      'pusherRef',
      'missionAlarms',
      'loadingMissionAlarms',
      'missionAlertsIntervalInstance',
      'showReloadAlarmsMessage',
      'intervalValueMissioAlarms'
    ]),
    ...mapGetters({
      role: 'auth/role',
      adminRole: 'auth/adminRole',
      user: 'auth/getProfile'
    })
  },
  methods: {
    ...mapActions([
      'fetchMissionAlarms',
      'setLoadingMissionAlarms',
      'setMissionAlertsIntervalInstance',
      'setShowReloadAlarmsMessage'
    ]),
    justifyAlert(alert, alarmName, alarmDescription) {
      if (alert.isJustified === null) {
        // console.log('CHANNELS', this.pusherRef)
        const channel = this.pusherRef.channels.channels['presence-justification-in-progress']
        // console.log('CHANNEL', channel)
        channel.trigger(
          'client-justification-in-progress',
          {
            i: alert.alarmId,
            a: alarmName,
            d: alarmDescription,
            t: 'mission',
            v: true,
            u: this.user.name
          }
        )
      }

      // console.log('ALARM FULL', this.missionAlarms)
      // console.log('ALERT', alert, alarmName, alarmDescription)
      const type = 'mission'
      this.alarmSelected = {...alert, alarmName, alarmDescription, type}
      // console.log('alarmSelected', this.alarmSelected)
      this.showJustification = true
    },
    fetchMissionAlarmsIn() {
      this.alarmsPendingToManualReload = false
      this.showMessage = false
      this.messageToShow = ''

      this.setShowReloadAlarmsMessage(false)

      clearInterval(this.missionAlertsIntervalInstance)
      this.$store.dispatch('clearMissionAlarms')
      this.setMissionAlertsIntervalInstance(null)

      this.setLoadingMissionAlarms(true)
      this.fetchMissionAlarms()
      this.intervalInstance1 = setInterval(() => {
        this.fetchMissionAlarms()
      }, this.intervalValueMissioAlarms)
      this.setMissionAlertsIntervalInstance(this.intervalInstance1)
    },
    cancelMessage() {
      this.alarmsPendingToManualReload = true
      this.setShowReloadAlarmsMessage(false)
    },
    showMessageIn(data) {
      this.messageToShow = data.message
      this.showMessage = true
    }
  },
  mounted() {
    this.setLoadingMissionAlarms(true)
    this.fetchMissionAlarms()
    this.intervalInstance1 = setInterval(() => {
      this.fetchMissionAlarms()
    }, this.intervalValueMissioAlarms)
    this.setMissionAlertsIntervalInstance(this.intervalInstance1)
  },
  beforeDestroy() {
    // console.log('BEFORE DESTROY MISSION ALERTS: ', this.intervalInstance1)
    clearInterval(this.missionAlertsIntervalInstance)
    this.$store.dispatch('clearMissionAlarms')
    this.setMissionAlertsIntervalInstance(null)
  }
}
</script>

<style lang="stylus" scoped>
a
  text-decoration none
  color white
  // font-size 16px

a:hover
  opacity 0.7

.justification-style
  min-width 80px
  max-width 80px
  text-align right

.bg-row
  background-color rgba(255, 255, 255, 0.07)
  border-radius 2px
.general-info-container
  height 60px
  border-radius 3px
  background-color #424242

 .info-width
  min-width 960px
  max-width 1024px

.header-container
  height 35px
  border-radius 3px
  background-color #424242
  font-size 16px
  font-weight 500

.info-mission
  min-width 290px 
  max-width 290px

.description-style
  min-width 390px
  max-width 390px

.plate-style
  min-width 120px
  max-width 120px

.code-style
  min-width 120px
  max-width 120px

.agency-style
  min-width 250px
  max-width 250px

.date-style
  min-width 180px
  max-width 180px

.info-vehicle-in
  height 40px

.message-reload-pending
  color #424242
  background-color #FFB300
  border-radius 3px
  max-width 340px
  height 45px
  line-height 11px

.hover-icon:hover
  cursor: pointer

.in-progress-state
  border dashed 1px #FFD54F
  border-radius 10px
  max-width 85px
  min-width 85px
  max-height 40px
  min-height 40px
  margin-left -15px
  padding-right 15px
</style>



// WEBPACK FOOTER //
// src/components/MissionAlerts.vue